export default __webpack_public_path__ + "static/media/Nithing Crossbow.a3902534.jpg";